// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "ayin-cursos-ba715.firebaseapp.com",
  "projectId": "ayin-cursos-ba715",
  "storageBucket": "ayin-cursos-ba715.appspot.com",
  "messagingSenderId": "792758149357",
  "appId": "1:792758149357:web:c1006c8399d7cddbdf2ce4",
  "measurementId": "G-9T0LT2GVH0",
  "apiKey": "AIzaSyAep7Z1_wFNxJ_hn6ArOwyzl9gzYtcpT4I"
};
